export default class View {
    static get() {
        return {
            is_open_to_work         : false,
            pdf_prefixes            : {
                fr: "T47sgA8UCRGs",
                en: "T47sgA8UCRGs"
            },
            title                   : "Carrière de la vie - Matthieu Barbaresco",
            default_meta_description: "Locution latine signifiant proprement « carrière (curriculum, de currere, “courir”) de la vie (vitae) »",
            my_email                : "matthieu@barbares.co",
            my_phone_label          : "06 18 60 44 97",
            my_phone_link           : "0618604497",
            my_address              : "6, rue Arthur III<br />44200 NANTES",
            mailjet_url             : "https://www.mailjet.com/fr/"
        };
    }
}